const COVERAGE_TYPES = {
  HOME: 'HOME',
  AUTO: 'AUTO',
  RENTERS: 'RENTERS',
  CONDO: 'CONDO',
  UMBRELLA: 'UMBRELLA'
};

const COVERAGE_TAGS = {
  LOW: 'LOW',
  MEDIUM: 'MEDIUM',
  HIGH: 'HIGH'
};

const YEARS_INSURED_OPTIONS = {
  LESS_THAN_6_MONTHS: '< 6 months',
  LESS_THAN_1_YEAR: '< 1 year',
  BETWEEN_1_AND_3_YEARS: '1-3 years',
  BETWEEN_3_AND_5_YEARS: '3-5 years',
  GREATER_THAN_5_YEARS: '5+ years'
};

const ALERT_PREFERENCES = {
  EMAIL_ONLY: 'Email Only',
  EMAIL_AND_TEXT: 'Email & Text'
};

const UI_ADDRESS_FIELDS = {
  CITY: 'city',
  COUNTRY: 'country',
  COUNTY: 'county',
  DISTRICT: 'district',
  HOUSE_NUMBER: 'houseNumber',
  POSTAL_CODE: 'postalCode',
  STATE: 'state',
  STREET: 'street',
  COMPOSITE: 'composite'
};

const ORIGINATOR = {
  ALERT_PREFERENCES: {
    ONLY_ME: 'ONLY_ME',
    CONSUMER_AND_ME: 'CONSUMER_AND_ME'
  }
};

const SCENARIOS = {
  PROOF: 'proof',
  DEALERSHIP_SHOP: 'dealership_shop',
  DEALERSHIP_REFERRAL: 'dealership_referral',
  DEALERSHIP_PICKER: 'dealership_picker',
  IV: 'iv', // insurance verification
  IC: 'ic', // insurance collection
  IV_CHECKLIST: 'iv_checklist',
  TEST_DRIVE: 'test_drive',
  SIGN_UP: 'sign_up',
  ESTIMATE: 'estimate'
};

const RISK_TYPES = {
  WILDFIRE: 'wildfire',
  FLOOD: 'flood',
  EARTHQUAKE: 'earthquake',
  WIND: 'wind',
  HURRICANE: 'hurricane',
  TORNADO: 'tornado',
  HAIL: 'hail',
  SINKHOLE: 'sinkhole'
};

const IV_REPORT_SENT_BY = {
  OPS: 'OPS',
  AUTO: 'AUTO'
};

const CONTEXT = {
  QUOTES: 'quotes',
  DASHBOARD: 'dashboard',
  IV: 'iv'
};

module.exports = {
  UI_ADDRESS_FIELDS,
  COVERAGE_TYPES,
  COVERAGE_TAGS,
  YEARS_INSURED_OPTIONS,
  ALERT_PREFERENCES,
  ORIGINATOR,
  SCENARIOS,
  RISK_TYPES,
  IV_REPORT_SENT_BY,
  CONTEXT
};
